import { Component } from '@angular/core';
import { ModalController, Platform, NavParams } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'app-countrylist',
    templateUrl: './countrylist.page.html',
    styleUrls: ['./countrylist.page.scss'],
})
export class CountrylistPage {
    orginalList: any = {};
    countryLists: any = {};
    requireData: string = 'countryCode';

    constructor(
        public platform: Platform,
        private navParams: NavParams,
        private modalCtrl: ModalController,
        private httpClient: HttpClient,
    ) {
        this.httpClient.get('assets/data/country.json')
            .pipe(res => res).subscribe(data => {
                this.countryLists = this.orginalList = data;
            });
        this.requireData = this.navParams.get('requireData');
    }
    getCountryList = (ev: any) => {
        var val = ev.target.value;
        if (val && val.trim() != '') {
            this.countryLists = this.countryLists
                .filter((country) => {
                    if (this.platform.isRTL)
                        return (country.short_name_arb.indexOf(val) > -1 || country.short_name.toLowerCase().indexOf(val.toLowerCase()) > -1);
                    else
                        return (country.short_name.toLowerCase().indexOf(val.toLowerCase()) > -1);
                }
                );
        }
    }
    clearCountryLists = () => {
        this.countryLists = this.orginalList;
    }
    selectedCountryItem = (countryData: any) => {
        this.modalCtrl.dismiss(countryData, 'close');
    }
    closeModal = () => {
        this.modalCtrl.dismiss(null, 'cancel');
    }
}
